import "./TrenitaliaLogo.css";

export const TrenitaliaLogo = ({ size = 28, className = "" }) => {
  const isFloatingButton = className.includes("floating");
  const isChatHeader = className.includes("chat-header");
  const isMessageAvatar = className.includes("message-avatar");

  const getLogoProps = () => {
    const cls = isMessageAvatar
      ? "message-avatar"
      : isFloatingButton
      ? "floating"
      : isChatHeader
      ? "chat-header"
      : "default";

    return {
      className: `trenitalia-logo-container ${cls}`,
      style: cls === "default" ? { width: size, height: size } : undefined,
    };
  };

  return (
    <div {...getLogoProps()}>
      <img
        src={`${process.env.PUBLIC_URL}/Trenitalia_logo_RDT.svg.png`}
        alt="Trenitalia Logo"
        className={
          isMessageAvatar ? "trenitalia-logo message-avatar" : "trenitalia-logo"
        }
      />
    </div>
  );
};
